// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
export const firebaseConfig = () => {
  if (process.env.NODE_ENV === "production") {
  
    return {
      apiKey: `REACT_APP_FIREBASE_API_KEY_PLACEHOLDER`,
      authDomain: `REACT_APP_FIREBASE_AUTH_DOMAIN_PLACEHOLDER`,
      projectId: `REACT_APP_FIREBASE_PROJECT_ID_PLACEHOLDER`,
      storageBucket: `REACT_APP_FIREBASE_STORAGE_BUCKET_PLACEHOLDER`,
      messagingSenderId: `REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PLACEHOLDER`,
      appId: `REACT_APP_FIREBASE_APP_ID_PLACEHOLDER`,
      measurementId: `REACT_APP_FIREBASE_MEASUREMENT_ID_PLACEHOLDER`,
    };
  }

  return {
    apiKey: "AIzaSyCR3jw6DAdnFmBjxeJjabKWlZE5lU8IZEw",
    authDomain: "airport-authority-irms.firebaseapp.com",
    projectId: "airport-authority-irms",
    storageBucket: "airport-authority-irms.firebasestorage.app",
    messagingSenderId: "251065815220",
    appId: "1:251065815220:web:98846f44db6a24fb1147e1",
    measurementId: "G-L30SN08769",
  };
};

const app = initializeApp(firebaseConfig());

// Initialize messaging with proper error handling
let messagingInstance = null;
let messagingPromise = null;

const initializeMessaging = async () => {
  if (messagingPromise) {
    return messagingPromise;
  }

  messagingPromise = (async () => {
    try {
      const supported = await isSupported();
      if (supported) {
        messagingInstance = getMessaging(app);
        console.info("Firebase Cloud Messaging initialized successfully");
        return messagingInstance;
      } else {
        console.warn("Firebase Cloud Messaging is not supported in this browser");
        return null;
      }
    } catch (error) {
      console.error("Error checking Firebase Cloud Messaging support:", error);
      return null;
    }
  })();

  return messagingPromise;
};

// Initialize messaging asynchronously
initializeMessaging();

// Export a function that returns the messaging instance or null
export const getMessagingInstance = () => messagingInstance;

// Export the messaging instance directly (for backward compatibility)
export { messagingInstance as messaging };
